// Import model
import { StartLeadStartZappRequest } from '../models/StartLeadStartZappRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadStartZappRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadStartZappRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadStartZappRequest instance
   */
  static deserialize(json: string): StartLeadStartZappRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadStartZappRequest instance
   */
  static fromObject(obj: any): StartLeadStartZappRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadStartZappRequest');
    }


    const instance: StartLeadStartZappRequest = {
      description: obj['Description'] as string | undefined,
      campaign: obj['Campaign'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadStartZappRequest instances
   */
  static deserializeArray(json: string): StartLeadStartZappRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadStartZappRequest instance to a JSON string
   */
  static serialize(instance: StartLeadStartZappRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadStartZappRequest instance to a plain object
   */
  static toObject(instance: StartLeadStartZappRequest): any {
    return {
      'Description': instance.description,
      'Campaign': instance.campaign,
    };
  }

  /**
   * Serializes an array of StartLeadStartZappRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadStartZappRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
